













import Vue from "vue";
import { computed } from "@vue/composition-api";
export default Vue.extend({
  props: {
    indeterminate: {
      type: Boolean,
      default: true
    },
    precentege: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const barWidth = computed(() =>
      props.indeterminate ? "100%" : props.precentege + "%"
    );
    return {
      barWidth
    };
  }
});
